import * as React from 'react';
import { Hr } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import '../../../../../../context/actions.js';
import '../../../../../../context/reducer.js';
import { useProductData } from '../../../../../../context/product-context-hooks.js';
import '../../../../../../context/ProductContext.js';
import '../../../../../../context/CmsContext.js';
import { ProductAnalyticsEvents } from '../../../../../Analytics/events/ProductAnalyticsEvents.js';
import { useEcommFacetContext } from '../../../../context/EcommFacetContext.js';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/inventory';
import { FacetPicker } from '../../../FacetPickers/components/FacetPicker.js';
import { FacetWithTextNode } from '../../../FacetPickers/components/FacetWithTextNode.js';
import { FacetWithImage } from '../../../FacetPickers/components/FacetWithImage.js';
import '@grandvisionhq/common';
import '@grandvisionhq/analytics';
import 'classnames';
import '@grandvisionhq/lib-utils-html';
import '../../../../../../types/product.js';
import '../../../../../VTO/context/VtoProvider.js';
import '@swc/helpers';
import '@grandvisionhq/utils';
import 'usehooks-ts';
import '@grandvisionhq/icons';
import '@grandvisionhq/frk-routing';
import { SingleVariantNode } from '../SingleVariantNode/SingleVariantNode.js';

const VariantTreeLevel = ({ className , treeLevelVariants , activeNode  })=>{
    const { getLabel  } = useIntl();
    const { activeVariant: { stock  } , product: { productType  } , facetConfigList ,  } = useProductData();
    const { handleVariantSelection  } = useEcommFacetContext();
    const facetConfig = facetConfigList === null || facetConfigList === void 0 ? void 0 : facetConfigList.find((config)=>{
        var ref;
        return config.facetKey === ((ref = treeLevelVariants[0]) === null || ref === void 0 ? void 0 : ref.facetKey);
    });
    const showStockIndicator = (facetConfig === null || facetConfig === void 0 ? void 0 : facetConfig.showStockIndicator) ? stock.enableStockIndicator : false;
    if (facetConfig === undefined || !treeLevelVariants.length && !showStockIndicator) return null;
    const title = getLabel(facetConfig.titleLabelKey);
    const handleFacetSelection = (props)=>{
        const { name , sku , facetTerm  } = props;
        ProductAnalyticsEvents.pushPdpVariantClickEvent({
            type: productType,
            name,
            id: sku,
            [facetConfig.facetKey]: facetTerm
        });
        handleVariantSelection(props);
    };
    const singleVariantFacet = treeLevelVariants.length === 1 ? treeLevelVariants[0] : undefined;
    if (singleVariantFacet && facetConfig.showSingleFacetAs !== 'display-type') {
        return /*#__PURE__*/ React.createElement(SingleVariantNode, {
            facetConfig: facetConfig,
            facetTerm: singleVariantFacet.facetTerm,
            showStockIndicator: showStockIndicator
        });
    }
    switch(facetConfig.displayType){
        case 'thumbnail':
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FacetPicker, {
                itemComponent: FacetWithImage,
                items: treeLevelVariants,
                onPick: handleFacetSelection,
                title: title,
                productType: productType,
                activeFacet: activeNode,
                showFacetName: true,
                className: className,
                enableStockIndicator: showStockIndicator
            }), /*#__PURE__*/ React.createElement(Hr, null));
        case 'text-node':
        default:
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FacetPicker, {
                itemComponent: FacetWithTextNode,
                facetTermFormatter: facetConfig.facetTermFormatter,
                items: treeLevelVariants,
                onPick: handleFacetSelection,
                title: title,
                productType: productType,
                activeFacet: activeNode,
                showFacetName: false,
                className: className,
                enableStockIndicator: showStockIndicator
            }), /*#__PURE__*/ React.createElement(Hr, null));
    }
};

export { VariantTreeLevel };
//# sourceMappingURL=VariantTreeLevel.js.map
